import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import usePopupStore from '../../store/popupStore';

// 앱 환경 확인 개선
const isInApp = () => {
    const userAgent = navigator.userAgent || '';
    return (
        /DayPay|daypay|AppWebView|wv|inapp|app/i.test(userAgent) ||
        typeof window.ReactNativeWebView !== 'undefined' ||
        typeof window.AppInterface !== 'undefined'
    );
};

function PaymentResult() {
    const navigate = useNavigate();
    const location = useLocation();
    const { showAlert } = usePopupStore();

    useEffect(() => {
        try {
            const query = new URLSearchParams(location.search);
            
            // 다양한 결제 성공 파라미터 확인
            const resultCode = query.get('resultCode') || query.get('P_STATUS');
            const status = query.get('status');
            const oid = query.get('oid') || query.get('P_OID');
            const price = query.get('price') || query.get('P_AMT') || query.get('settleprice');
            const orderKind = query.get('order_kind') || 'parcel';
            
            // 결제 성공 조건 확인 (더 포괄적으로)
            const isPaymentSuccess = (
                resultCode === '0000' || 
                resultCode === 'success' || 
                status === 'succ' ||
                status === 'success'
            );
            
            if (isPaymentSuccess && oid) {
                
                const paymentInfo = {
                    success: true,
                    orderSeq: oid,
                    settleprice: price || '0',
                    orderKind: orderKind
                };
                
                // 결제 진행 상태 정리
                localStorage.removeItem('payment_in_progress');
                localStorage.removeItem('payment_start_time');
                localStorage.removeItem('payment_return_path');
                localStorage.removeItem('payment_order_id');
                
                // 앱 환경 처리
                if (isInApp()) {
                    
                    // 앱에서는 결제 성공 정보를 로컬스토리지에 저장
                    localStorage.setItem('paymentResultInfo', JSON.stringify(paymentInfo));
                    
                    // ReactNative와 통신
                    if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            type: 'payment_success',
                            paymentInfo: paymentInfo
                        }));
                    }
                    
                    // 성공 알림 표시
                    alert('주문이 완료되었습니다.\n주문정보는 마이페이지에서 확인 가능합니다.');
                    
                    // 주문 완료 페이지로 이동
                    navigate(`/order/orderComplete/${oid}`, { 
                        state: { 
                            order_seq: oid,
                            settleprice: price,
                            order_kind: orderKind 
                        },
                        replace: true // 뒤로가기 방지
                    });
                    
                    return;
                }
                
                // 웹 환경 처리
                if (window.opener) {
                    // 부모 창에 결제 성공 메시지 전달
                    window.opener.postMessage({
                        type: 'payment_success',
                        resultCode: '0000',
                        oid: oid,
                        price: price,
                        order_kind: orderKind
                    }, '*');
                    
                    // 현재 창 닫기
                    window.close();
                } else {
                    // opener가 없는 경우 직접 이동
                    alert('주문이 완료되었습니다.\n주문정보는 마이페이지에서 확인 가능합니다.');
                    navigate(`/order/orderComplete/${oid}`, { 
                        state: { 
                            order_seq: oid,
                            settleprice: price,
                            order_kind: orderKind 
                        },
                        replace: true
                    });
                }
            } else if (resultCode && resultCode !== '0000' && resultCode !== 'success') {
                // 결제 실패
                
                const errorMessage = query.get('resultMsg') || query.get('P_RMESG') || "결제에 실패했습니다.";
                
                // 결제 진행 상태 정리
                localStorage.removeItem('payment_in_progress');
                localStorage.removeItem('payment_start_time');
                
                if (isInApp()) {
                    alert(errorMessage);
                    
                    const originalPath = localStorage.getItem('payment_return_path') || '/order/parcel';
                    localStorage.removeItem('payment_return_path');
                    localStorage.removeItem('payment_order_id');
                    navigate(originalPath, { replace: true });
                    return;
                }
                
                if (window.opener) {
                    window.opener.postMessage({
                        type: 'payment_failure',
                        resultCode: resultCode,
                        resultMsg: errorMessage
                    }, '*');
                    window.close();
                } else {
                    alert(errorMessage);
                    navigate('/order/parcel', { replace: true });
                }
            } else {
                // 결제 정보가 없거나 불완전한 경우
                
                // 결제 진행 상태 정리
                localStorage.removeItem('payment_in_progress');
                localStorage.removeItem('payment_start_time');
                
                if (isInApp()) {
                    alert("결제 정보가 없습니다. 다시 시도해주세요.");
                    
                    const originalPath = localStorage.getItem('payment_return_path') || '/order/parcel';
                    localStorage.removeItem('payment_return_path');
                    localStorage.removeItem('payment_order_id');
                    navigate(originalPath, { replace: true });
                    return;
                }
                
                if (window.opener) {
                    alert("결제 정보가 없습니다. 다시 시도해주세요.");
                    window.opener.location.reload();
                    window.close();
                } else {
                    alert("결제 정보가 없습니다. 다시 시도해주세요.");
                    navigate('/order/parcel', { replace: true });
                }
            }
        } catch (error) {
            console.error("❌ 결제 결과 처리 중 오류:", error);
            
            // 오류 발생 시 정리
            localStorage.removeItem('payment_in_progress');
            localStorage.removeItem('payment_start_time');
            
            if (isInApp()) {
                alert("결제 처리 중 오류가 발생했습니다.");
                
                const originalPath = localStorage.getItem('payment_return_path') || '/order/parcel';
                localStorage.removeItem('payment_return_path');
                localStorage.removeItem('payment_order_id');
                navigate(originalPath, { replace: true });
            } else {
                if (window.opener) {
                    alert("결제 처리 중 오류가 발생했습니다.");
                    window.opener.location.reload();
                    window.close();
                } else {
                    alert("결제 처리 중 오류가 발생했습니다.");
                    navigate('/order/parcel', { replace: true });
                }
            }
        }
    }, [location.search, navigate, showAlert]);

    // 로딩 화면 표시
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column'
        }}>
            <div>결제 결과를 처리하고 있습니다...</div>
            <div style={{ marginTop: '10px', fontSize: '14px', color: '#666' }}>
                잠시만 기다려주세요.
            </div>
        </div>
    );
}

export default PaymentResult;